import React from 'react';
import { Bot } from 'lucide-react';
import type { TypingIndicatorProps } from '../../types/chat';

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ 
  isVisible, 
  message = "AI đang nhập..." 
}) => {
  if (!isVisible) return null;

  return (
    <div 
      className="flex gap-3 mb-4 animate-fade-in"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      {/* AI Avatar */}
      <div className="flex-shrink-0 w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
        <Bot className="w-6 h-6 text-white" aria-hidden="true" />
      </div>

      {/* Typing indicator bubble */}
      <div className="flex flex-col max-w-[80%]">
        <div className="bg-gray-100 text-gray-900 px-4 py-3 rounded-2xl rounded-bl-md shadow-sm">
          <div className="flex items-center gap-2">
            {/* Animated dots */}
            <div className="flex gap-1" aria-hidden="true">
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-typing-dot-1"></div>
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-typing-dot-2"></div>
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-typing-dot-3"></div>
            </div>
            
            {/* Typing text */}
            <span className="text-sm text-gray-600 ml-1">
              {message}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;